<div class="banner d-lg-flex d-none w-100" role="banner">
  <div class="container d-flex text-white d-flex justify-content-between h-100 align-items-center overflow-hidden">
    @if(pageTitle){
    <h2 class="m-0">
      {{ pageTitle }}
    </h2>
    }@else {
    <ng-container *ngTemplateOutlet="template"></ng-container>
    }
    <img class="club-logo" src="assets/images/club-logo.png" alt="club-logo" />
  </div>
</div>
